import ContentStorage from '../../tnew/content/ContentStorage';


const COMPONENT_KEY = 'c97b1fb9-6cdb-4f3e-b302-f5d0b188e3d9';

const get = name => ContentStorage.get(COMPONENT_KEY, name);


class OnePageGivingComponent {
  static get errorMessage() {
    return get('ErrorMessage');
  }
}


export default OnePageGivingComponent;



// WEBPACK FOOTER //
// ./src/onePageGiving/components/OnePageGivingComponent.js